/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Review_Status_Not_EditableInputs */

const es_co2_error_review_status_not_editable = /** @type {(inputs: Error_Review_Status_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario ya no se puede editar.`)
};

/**

* @param {Error_Review_Status_Not_EditableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_review_status_not_editable = /** @type {((inputs?: Error_Review_Status_Not_EditableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Review_Status_Not_EditableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_review_status_not_editable(inputs)
});